import React from 'react';
import { Information } from './common';
import { messageUtility } from '../../utilities/messageUtility';
import LocalStorageService from '../../services/utilities/LocalStorageService';
import { isPrimeRoleId } from '../../utilities/roleUtility';

export const UserAccessExpiredModal = ({ visible, onClose }) => {
  // const userId = LocalStorageService.getUserId();
  const roleId = LocalStorageService.getRoleId();
  if (isPrimeRoleId(roleId)) {
    return null;
  } else {
    return (
      <Information
        rootClassName='FieldsExpiredUsageModal'
        title='現場にアクセスできません'
        buttonText={messageUtility.getMessage('I-000-017')}
        visible={visible}
        onClose={onClose}
        message={
          <div className='description'>
            あなたのアカウントが作業終了または現場から削除されたため、この現場へのアクセスができませんでした。
            <br />
            現場に再度アクセスが必要な場合、元請ユーザーかこの現場にアクセスできる自社の協力会社管理者に操作をご依頼ください。
          </div>
        }
      />
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/modals/UserAccessExpiredModal.jsx